[
  {
    "code": "ET-AA",
    "name": "Addis Ababa"
  },
  {
    "code": "ET-AF",
    "name": "Afar"
  },
  {
    "code": "ET-AM",
    "name": "Amara"
  },
  {
    "code": "ET-BE",
    "name": "Benshangul-Gumaz"
  },
  {
    "code": "ET-DD",
    "name": "Dire Dawa"
  },
  {
    "code": "ET-GA",
    "name": "Gambela Peoples"
  },
  {
    "code": "ET-HA",
    "name": "Harari People"
  },
  {
    "code": "ET-OR",
    "name": "Oromia"
  },
  {
    "code": "ET-SO",
    "name": "Somali"
  },
  {
    "code": "ET-SN",
    "name": "Southern Nations, Nationalities and Peoples"
  },
  {
    "code": "ET-TI",
    "name": "Tigrai"
  }
]